import React from 'react';
import CartItemShuttle from '../CartItemShuttle';
import CartItemTicket from '../CartItemTicket';
import CartItemParking from '../CartItemParking';
import CartItemWheels from '../CartItemWheels';

import shuttlePurpleIcon from '../../../assets/images/Shuttle/CBX_purpleShuttle.svg';

// eslint-disable-next-line require-jsdoc
const CartItem = ({
  product,
  index,
  locale,
  strings,
  editFn,
  deleteFn
}) => {


  let Item = <></>;

  if (product.type === 'ticket' && !product.donation) {
    Item = <CartItemTicket product={product} index={index} locale={locale} strings={strings} editFn={editFn} deleteFn={deleteFn}/>;
  }
  if (product.type === 'parking') {
    Item = <CartItemParking product={product} index={index} locale={locale} strings={strings} editFn={editFn} deleteFn={deleteFn}/>;
  }
  if (product.type === 'shuttle') {
    Item = <CartItemShuttle product={product} index={index} locale={locale} strings={strings} editFn={editFn} deleteFn={deleteFn}/>;
  }
  if (product.type === 'wheels') {
    Item = <CartItemWheels product={product} index={index} locale={locale} strings={strings} editFn={editFn} deleteFn={deleteFn}/>;
  }
  return Item;
};

export default CartItem;
